/** Route definitions for v2 marketing pages (component name = file under Pages/v2/) */
const v2RouteDefs = [
  { path: "/case-studies", page: "CaseStudiesHub", exact: true },
  { path: "/case-studies/:caseStudySlug", page: "CaseStudyDetailPage", exact: true },
  { path: "/solutions", page: "SolutionsHub", exact: true },
  { path: "/solutions/:solutionSlug", page: "SolutionDetailPage", exact: true },
  { path: "/technologies", page: "TechnologiesHub", exact: true },
  { path: "/technologies/:technologySlug", page: "TechnologyDetailPage", exact: true },
  { path: "/resources", page: "ResourcesHub", exact: true },
  { path: "/resources/:resourceSlug", page: "ResourceDetailPage", exact: true },
  { path: "/services/:serviceSlug/:subServiceSlug", page: "SubServiceDetailPage", exact: true },
  { path: "/services/:serviceSlug", page: "ServiceDetailPage", exact: true },
  { path: "/who-we-are/:pageSlug", page: "WhoWeAreDetailPage", exact: true },
  { path: "/careers/:jobSlug", page: "JobDetailPage", exact: true },
];

export default v2RouteDefs;
